// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3t_9U","name":"name-2gGzO","iata":"iata-3C6aZ"};